import { GlTruncateText, GlSprintf, GlIcon } from '@gitlab/ui';
import { __, s__ } from '~/locale';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { SHORT_DATE_FORMAT } from '~/vue_shared/constants';
import { formatDate, newDate } from '~/lib/utils/datetime_utility';
export default {
    name: 'ListItemDescription',
    i18n: {
        showMore: __('Show more'),
        showLess: __('Show less'),
        scheduledDeletion: s__('ResourceListItem|Scheduled for deletion on %{date}')
    },
    truncateTextToggleButtonProps: {
        class: '!gl-text-sm'
    },
    components: {
        GlTruncateText,
        GlSprintf,
        GlIcon
    },
    directives: {
        SafeHtml
    },
    inheritAttrs: false,
    props: {
        resource: {
            type: Object,
            required: true
        }
    },
    computed: {
        description () {
            return this.resource.description;
        },
        descriptionHtml () {
            return this.resource.descriptionHtml;
        },
        isPendingDeletion () {
            return Boolean(this.resource.markedForDeletion);
        },
        formattedDate () {
            return formatDate(newDate(this.resource.permanentDeletionDate), SHORT_DATE_FORMAT);
        },
        showDescription () {
            return (this.description || this.descriptionHtml) && !this.resource.archived;
        }
    }
};
